import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Select from 'react-select';
import { useMsal } from '@azure/msal-react';
import { fetchAuthorized } from '../../utils/fetchAuthorized';
import { Card, CardBody } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';

const enterpriseTypes = [
    { value: "Private Equity", label: "Private Equity" },
    { value: "Privately Owned", label: "Privately Owned" },
    { value: "Public", label: "Public" },
    { value: "Government", label: "Government" },
    { value: "Non-profit", label: "Non-profit" }
];
const sizes = [
    { value: "50,000+", label: "50,000+" },
    { value: "25,000-49,999", label: "25,000-49,999" },
    { value: "10,000-24,999", label: "10,000-24,999" },
    { value: "5,000-9,999", label: "5,000-9,999" },
    { value: "2,500-4,999", label: "2,500-4,999" },
    { value: "1,500-2,499", label: "1,500-2,499" },
    { value: "500-1,500", label: "500-1,500" },
    { value: "100-499", label: "100-499" },
    { value: "1-99", label: "1-99" }
];
const annualRevenues = [
    { value: "$25B+", label: "$25B+" },
    { value: "$5B-$24.9B", label: "$5B-$24.9B" },
    { value: "$1B-$4.9B", label: "$1B-$4.9B" },
    { value: "$500M-$999M", label: "$500M-$999M" },
    { value: "$100M-$499M", label: "$100M-$499M" },
    { value: "$50-$99M", label: "$50-$99M" },
    { value: "$10M-49M", label: "$10M-49M" },
    { value: "$1-$9.9M", label: "$1-$9.9M" }
];
const industries = [
    { value: "Technology", label: "Technology" },
    { value: "Finance", label: "Finance" },
    { value: "Healthcare & Biotech", label: "Healthcare & Biotech" },
    { value: "Energy", label: "Energy" },
    { value: "Education", label: "Education" },
    { value: "Retail", label: "Retail" },
    { value: "Manufacturing", label: "Manufacturing" }
];

export function AddEnterprise(props) {
    const { instance } = useMsal();
    const [error, setError] = useState(null);
    const [show, setShow] = useState(false);
    const [name, setName] = useState("");
    const [type, setType] = useState();
    const [size, setSize] = useState("");
    const [annualRevenue, setAnnualRevenue] = useState("");
    const [industry, setIndustry] = useState("");

    const handleCancel = () => {
        if(props.modal)
            setShow(false);
        else
            props.handleCancelAddEnterprise();
    }

    const handleAddEnterprise = async (event) => {
        event.preventDefault();
        setShow(false);

        //check for existing enterprise
        if (props.enterprises.find(a => a.name === name))
            throw new Error(`Could not add enterprise. ${name} already exists.`);

        try {
            var params = {
                method: "POST",
                body: JSON.stringify({
                    name,
                    createdDate: new Date(),
                    type: type.value,
                    size: size.value,
                    industry: industry.value,
                    annualRevenue: annualRevenue.value
                }),
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                }
            };
            const response = await fetchAuthorized(instance, `${process.env.REACT_APP_API_URL}Enterprises`, params);
            if (!response.ok) {
                throw new Error('Could not add Enterprise.');
            }
            const data = await response.json();
            props.handleAddEnterprise(data);
        } catch (error) {
            setError(error.message);
        }
    };

    if (error)
        return (<p>Error: {error}</p>)

    if (props.modal) {
        return (
            <>
                <div>
                    <Button variant="primary" className="mt-3" onClick={() => setShow(true)}>
                        Add Enterprise
                    </Button>
                </div>

                    <Modal variant="large" show={show} onHide={handleCancel}>
                        <Modal.Header closeButton>
                            <Modal.Title>Add Enterprise</Modal.Title>
                        </Modal.Header>
                        <Form onSubmit={handleAddEnterprise}>
                            <Modal.Body>
                                <Form.Group controlId="name" className="mb-3">
                                    <Form.Label>Enterprise Name</Form.Label>
                                    <Form.Control type="text" required onChange={(event) => setName(event.target.value)} placeholder="Organiztion Name" />
                                </Form.Group>
                                <Form.Group controlId="type" className="mb-3">
                                    <Form.Label>Enterprise Type</Form.Label>
                                    <Select
                                        aria-label='type'
                                        placeholder="Select Enterprise Type"
                                        required
                                        options={enterpriseTypes}
                                        value={type}
                                        onChange={(value) => setType(value)}
                                    />
                                </Form.Group>
                                <Form.Group controlId="size" className="mb-3">
                                    <Form.Label>Size</Form.Label>
                                    <Select
                                        aria-label='size'
                                        placeholder="Select Enterprise Size"
                                        required
                                        options={sizes}
                                        value={size}
                                        onChange={(value) => setSize(value)}
                                    />
                                </Form.Group>
                                <Form.Group controlId="annualRevenue" className="mb-3">
                                    <Form.Label>Annual Revenue</Form.Label>
                                    <Select
                                        aria-label='annualRevenue'
                                        placeholder="Select Annual Revenue"
                                        required
                                        options={annualRevenues}
                                        value={annualRevenue}
                                        onChange={(value) => setAnnualRevenue(value)}
                                    />
                                </Form.Group>
                                <Form.Group controlId="industry" className="mb-3">
                                    <Form.Label>Industry</Form.Label>
                                    <Select
                                        aria-label='industry'
                                        placeholder="Select Industry"
                                        required
                                        options={industries}
                                        value={industry}
                                        onChange={(value) => setIndustry(value)}
                                    />
                                </Form.Group>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleCancel}>
                                        Close
                                    </Button>
                                    <Button variant="primary" type="submit">
                                        Save
                                    </Button>
                                </Modal.Footer>
                            </Modal.Body>
                        </Form>
                    </Modal>
            </>
        );
    }

    return (
        <Card className='mt-3 mb-3'>
            {/* <CardHeader>Add Enterprise</CardHeader> */}
            <CardBody>
                <Form onSubmit={handleAddEnterprise}>
                    <Form.Group className="mb-3">
                        <Form.Label>Enterprise Name: </Form.Label>
                        <Form.Control type="text" required onChange={(event) => setName(event.target.value)} placeholder="Organiztion Name" />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Enterprise Type: </Form.Label>
                        <Select
                            aria-label='type'
                            placeholder="Select Enterprise Type"
                            required
                            options={enterpriseTypes}
                            value={type}
                            onChange={(value) => setType(value)}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Size: </Form.Label>
                        <Select
                            aria-label='size'
                            placeholder="Select Enterprise Size"
                            required
                            options={sizes}
                            value={size}
                            onChange={(value) => setSize(value)}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Annual Revenue: </Form.Label>
                        <Select
                            aria-label='annualRevenue'
                            placeholder="Select Annual Revenue"
                            required
                            options={annualRevenues}
                            value={annualRevenue}
                            onChange={(value) => setAnnualRevenue(value)}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Industry: </Form.Label>
                        <Select
                            aria-label='industry'
                            placeholder="Select Industry"
                            required
                            options={industries}
                            value={industry}
                            onChange={(value) => setIndustry(value)}
                        />
                    </Form.Group>
                    <div className="mt-3 text-end">
                        <Button variant="secondary" onClick={handleCancel}>
                            Cancel
                        </Button>
                        <Button variant="primary" className="ms-2" type="submit">
                            Add
                        </Button>
                    </div>
                </Form>
            </CardBody>
        </Card>
    );
}